import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

export function CopyEmail({ email, className = '' }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {}
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`inline-flex items-center justify-center w-4 h-4 rounded hover:bg-slate-200 transition-colors shrink-0 ${className}`}
      title="Copy email"
      data-testid={`copy-email-${email}`}
    >
      {copied ? <Check className="w-3 h-3 text-emerald-500" /> : <Copy className="w-3 h-3 text-slate-400 hover:text-slate-600" />}
    </button>
  );
}
